"use client";

import { Button } from "@/components/ui/button-pro";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Download, ExternalLink, FileText } from "lucide-react";
import { RESUME_EN_LINK } from "@/lib/constants";
import { useState } from "react";
import { FuturisticLoadingSpinner } from "./loading-spinner";
import { DownloadResumeModal, ViewResumeModal } from "./mouheb/resume-modal";

export function DownloadResume() {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    // const resumePath = "/resume/hamza-missaoui-resume-en.pdf";
    const resumePath = "/resume/Hamza_Missaoui_Resume.pdf";
    const defaultFilename = "Hamza_Missaoui_Resume.pdf";

    setLoading(true);
    try {
      // Prompt user for filename
      const userFilename = window.prompt(
        "Enter a filename to save as:",
        defaultFilename
      );

      if (!userFilename) {
        // User clicked cancel
        return;
      }

      setLoading(true);

      // Ensure the filename ends with .pdf
      const filename = userFilename.endsWith(".pdf")
        ? userFilename
        : `${userFilename}.pdf`;

      // Fetch the file first
      const response = await fetch(resumePath);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create and trigger download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading resume:", error);
      alert("Failed to download resume. Please try again.");
    } finally {
      // document.body.removeChild(link);
      setLoading(false);
    }
  };

  const handleView = () => {
    window.open(RESUME_EN_LINK, "_blank");
  };

  return (
    <Card className="w-full max-w-md bg-card border-border">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
          <FileText className="h-6 w-6 text-primary" />
        </div>
        <CardTitle className="text-card-foreground">Resume</CardTitle>
        <CardDescription className="text-muted-foreground">
          Download or view my latest resume
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Button
          onClick={handleView}
          variant="outline"
          className="w-full h-12 bg-background text-foreground hover:bg-accent hover:text-accent-foreground"
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          View Resume
        </Button>
        <Button
          onClick={handleDownload}
          className="w-full h-12 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground"
          variant="outline"
        >
          <Download className="mr-2 h-4 w-4" />
          Download Resume
          {loading && <FuturisticLoadingSpinner />}
        </Button>
      </CardContent>
    </Card>
  );
}

export function DownloadResumeWithModal() {
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // const handleView = () => {
  //     window.open(RESUME_DRIVE_LINK, '_blank');
  // };

  return (
    <Card className="w-full border border-t-transparent">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
          <FileText className="h-6 w-6 text-primary" />
        </div>
        <CardTitle className="text-card-foreground">Resume</CardTitle>
        <CardDescription className="text-muted-foreground">
          Download or view my latest resume
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <ViewResumeModal />
        {/* <Button
                    onClick={handleView}
                    variant='outline'
                    className='w-full h-12 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground'>
                    <ExternalLink className='mr-2 h-4 w-4' />
                    View Resume
                    </Button> */}

        <DownloadResumeModal />
        {/* <Button
                        onClick={() => setIsModalOpen(true)}
                        className='w-full h-12 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground'
                        variant="outline">
                        <Download className='mr-2 h-4 w-4' />
                        My Resume
                    </Button> */}
      </CardContent>
    </Card>
  );
}
